import compose from 'utils/composeEnhancer'
import handlersCms from './handlersCms'

export default compose(
  handlersCms
)
